module.exports = __webpack_public_path__ + "static/media/chart-42k-v2.720a0009.svg";